import { useState, useMemo } from "react";
import "./PenaltyOvertimeDetails.css";
import { Form, Row, Col } from "react-bootstrap";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { AgGridReact } from "ag-grid-react";
// Icons -----------------------------------------
import { RiEdit2Line } from "react-icons/ri";
import { CgFileDocument } from "react-icons/cg";
import { FiPlus } from "react-icons/fi";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
// Components -----------------------------------------
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import WidgetsButton from "../../../components/Widgets/button";
import InfoCard from "../../../components/InfoCard";
import { HasPermission } from "../../../services/hasPermission";

const PenaltyOvertimeDetails = ({ user, userDetails, commonState }) => {
  const tabItem = [
    { name: "Early Leave Policy", item: <EarlyLeavePolicy /> },
    { name: "Late Coming Policy", item: <LateComingPolicy /> },
    { name: "Over Time Policy", item: <OverTimePolicy /> },
  ];
  const [highlightTap, setHighlightTap] = useState(0);
  const [penaltyDetails, setPenaltyDetails] = useState([]);
  const [overtimeDetails, setOvertimeDetails] = useState([]);
  const [open, setOpen] = useState(false);

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  const columns1 = useMemo(
    () => [
      {
        headerName: "Date",
        width: "130px",
        cellRenderer: (rowData) => {
          return <span>{rowData.data.mobileNumber}</span>;
        },
      },
      {
        headerName: "Duration",
        width: "120px",
        cellRenderer: (rowData) => {
          return <span>{rowData.data.employeeId}</span>;
        },
      },
      {
        headerName: "Fine",
        field: "jobTitle",
        width: "130px",
      },
    ],
    []
  );

  const columns2 = useMemo(
    () => [
      {
        headerName: "Date",
        width: "130px",
        cellRenderer: (rowData) => {
          return <span>{rowData.data.mobileNumber}</span>;
        },
      },
      {
        headerName: "Duration",
        width: "120px",
        cellRenderer: (rowData) => {
          return <span>{rowData.data.employeeId}</span>;
        },
      },
      {
        headerName: "Amount",
        field: "jobTitle",
        width: "130px",
      },
    ],
    []
  );

  const preSubmit = () => {
    document.getElementById("submit-btn").click();
  };

  const submitForm = () => {
    alert("hello mani");
  };

  return (
    <div style={{ padding: "0 10px" }}>
      <Row className="mb-3">
        <Col sm="6" className="mb-3">
          <Widgets
            icon={
              <WidgetsIcon icon={<CgFileDocument />} title="Penalty Policy" />
            }
            button={
              HasPermission("Penalty & Overtime Details", "edit") && (
                <WidgetsButton
                  type="button"
                  icon={<RiEdit2Line className="btn-icon" />}
                  onClick={() => setOpen(true)}
                />
              )
            }
            body={
              <>
                <div className="uni-flex-space-between">
                  <span className="color-gray">Fine Type</span>
                  <span className="color-white">-</span>
                  {/* <span className="color-white">Hourly</span> */}
                </div>

                <div className="uni-flex-space-between">
                  <span className="color-gray">Grace Period</span>
                  <span className="color-white">-</span>
                  {/* <span className="color-white">15 Mins</span> */}
                </div>

                <div className="uni-flex-space-between">
                  <span className="color-gray">Fine Amount</span>
                  <span className="color-white">-</span>
                  {/* <span className="color-white">₹ 20</span> */}
                </div>

                <div className="uni-flex-space-between">
                  <span className="color-gray">Waive Off Days</span>
                  <span className="color-white">-</span>
                  {/* <span className="color-white">1 Day</span> */}
                </div>
              </>
            }
          />
        </Col>

        <Col sm="6" className="mb-3">
          <Widgets
            icon={
              <WidgetsIcon icon={<CgFileDocument />} title="Overtime Policy" />
            }
            button={
              HasPermission("Penalty & Overtime Details", "edit") && (
                <WidgetsButton
                  type="button"
                  icon={<RiEdit2Line className="btn-icon" />}
                  onClick={null}
                />
              )
            }
            body={
              <>
                <div className="uni-flex-space-between">
                  <span className="color-gray">Grace Period</span>
                  <span className="color-white">-</span>
                  {/* <span className="color-white">1 Hour</span> */}
                </div>
                <div className="uni-flex-space-between">
                  <span className="color-gray">Extra Pay</span>
                  <span className="color-white">-</span>
                  {/* <span className="color-white">₹ 20</span> */}
                </div>

                <div className="uni-flex-space-between">
                  <span className="color-gray">Public Holiday Pay</span>
                  <span className="color-white">-</span>
                  {/* <span className="color-white">₹ 120</span> */}
                </div>

                <div className="uni-flex-space-between">
                  <span className="color-gray">Waive Off Pay</span>
                  <span className="color-white">-</span>
                  {/* <span className="color-white">₹ 120</span> */}
                </div>
              </>
            }
          />
        </Col>

        <Col sm="6" className="mb-3">
          <Widgets
            icon={
              <WidgetsIcon
                icon={<RiMoneyDollarCircleLine />}
                title="Penalty Details"
              />
            }
            button={
              HasPermission("Penalty & Overtime Details", "create") && (
                <WidgetsButton
                  type="button"
                  icon={<FiPlus className="btn-icon" />}
                  onClick={null}
                />
              )
            }
            body={
              <>
                <Row className="mt-3">
                  <Col sm="6" className="mb-3">
                    <InfoCard title={"total Penalty Hours"} value={"-"} />
                  </Col>
                  <Col sm="6" className="mb-3">
                    <InfoCard title={"Total Deduction"} value={"-"} />
                  </Col>

                  <Col sm="12">
                    <div
                      className="ag-theme-quartz custom-grid"
                      style={{
                        position: "relative",
                        height: "480px",
                        width: "100%",
                        padding: "10px 20px",
                        zIndex: "0",
                      }}
                    >
                      <AgGridReact
                        rowData={
                          Array.isArray(penaltyDetails) ? penaltyDetails : []
                        }
                        columnDefs={columns1}
                        omLayout="autoHeight"
                        pagination={true}
                        paginationPageSize={paginationPageSize}
                        paginationPageSizeSelector={paginationPageSizeSelector}
                      />
                    </div>
                  </Col>
                </Row>
              </>
            }
          />
        </Col>

        <Col sm="6" className="mb-3">
          <Widgets
            icon={
              <WidgetsIcon
                icon={<RiMoneyDollarCircleLine />}
                title="Overtime  Details"
              />
            }
            button={
              HasPermission("Penalty & Overtime Details", "create") && (
                <WidgetsButton
                  type="button"
                  icon={<FiPlus className="btn-icon" />}
                  onClick={null}
                />
              )
            }
            body={
              <>
                <Row className="mt-3">
                  <Col sm="6" className="mb-3">
                    <InfoCard title={"Total Overtime Hours"} value={"-"} />
                  </Col>
                  <Col sm="6" className="mb-3">
                    <InfoCard title={"Total Overtime Earned"} value={"-"} />
                  </Col>

                  <Col sm="12">
                    <div
                      className="ag-theme-quartz custom-grid"
                      style={{
                        position: "relative",
                        height: "480px",
                        width: "100%",
                        padding: "10px 20px",
                        zIndex: "0",
                      }}
                    >
                      <AgGridReact
                        rowData={
                          Array.isArray(overtimeDetails) ? overtimeDetails : []
                        }
                        columnDefs={columns2}
                        omLayout="autoHeight"
                        pagination={true}
                        paginationPageSize={paginationPageSize}
                        paginationPageSizeSelector={paginationPageSizeSelector}
                      />
                    </div>
                  </Col>
                </Row>
              </>
            }
          />
        </Col>
      </Row>

      <Dialog
        fullWidth={true}
        open={open}
        onClose={() => setOpen(false)}
      // style={{ width: "30%", margin: "0 auto" }}
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={() => setOpen(false)}>
              X
            </span>
            <span className="title">Edit Penalty Policy</span>
          </div>
          <button className="universal-btn" onClick={preSubmit}>
            Save Changes
          </button>
        </DialogTitle>

        <DialogContent
          style={{
            fontSize: "16px",
            fontWeight: "400",
          }}
        >
          <Form onSubmit={submitForm} className="mt-3">
            <Row>
              <Col sm="6" className="mb-3">
                <Form.Group>
                  <Form.Label className="color-gray mb-2">Fine Type</Form.Label>
                  <Form.Select name="" value="" className="universal-input">
                    <option value="">Select Fine</option>
                    <option value="hourly">Hourly</option>
                    <option value="weekly">Weekly</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col sm="6" className="mb-3">
                <Form.Group>
                  <Form.Label className="color-gray mb-2">
                    Grace Period (mins)
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    value=""
                    placeholder="Enter Grace Period"
                    className="universal-input"
                  />
                </Form.Group>
              </Col>

              <Col sm="6" className="mb-3">
                <Form.Group>
                  <Form.Label className="color-gray mb-2">
                    Fine Amount
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    value=""
                    placeholder="&#8377; 120"
                    className="universal-input"
                  />
                </Form.Group>
              </Col>

              <Col sm="6" className="mb-3">
                <Form.Group>
                  <Form.Label className="color-gray mb-2">
                    Waive of Days
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    value=""
                    placeholder="2"
                    className="universal-input"
                  />
                </Form.Group>
              </Col>

              <button
                type="submit"
                style={{ display: "none" }}
                id="submit-btn"
              ></button>
            </Row>
          </Form>
        </DialogContent>
      </Dialog>

      {/*  */}
      {/* <div className="PenaltyOvertimeDetails">
      <div className="PenaltyOvertimeDetails-body">
        <p> Penalty & Overtime Details</p>
        <div className="PenaltyOvertimeDetail-card">
          <div className="PenaltyOvertimeDetail-tab-List">
            {tabItem.map((item, i) => (
              <p
                style={{
                  borderBottom:
                    highlightTap === i ? "2px solid rgb(147, 147, 147)" : "",
                  fontSize: "16px",
                }}
                key={i}
                onClick={() => setHighlightTap(i)}
              >
                {item.name}
              </p>
            ))}
          </div>

          <ButtonCom
            type="button"
            class_name="p_btn"
            text="Add Document"
            url_or_onclick={null}
            icon={null}
            width={""}
          />
        </div>

        <div className="PenaltyOvertimeDetail-tab-item">
          {tabItem.map((item, i) => (
            <div key={i}>{highlightTap === i ? <>{item.item}</> : <></>}</div>
          ))}
        </div>
      </div>
    </div> */}
    </div>
  );
};

const EarlyLeavePolicy = () => {
  return (
    <Form>
      <Form.Group>
        <div style={{ display: "flex", justifyContent: "start", gap: "20px" }}>
          <Form.Label>Fine Type</Form.Label>
          <Form.Check
            type="radio"
            name="fineType"
            value={"Daily"}
            label="Daily"
            required
          />
          <Form.Check
            type="radio"
            name="fineType"
            value={"Hourly"}
            label="Hourly"
            required
          />
        </div>
      </Form.Group>
      <Row>
        <Col sm="6">
          <Form.Group className="mt-3">
            <Form.Label>
              Grace Period (mis) <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              name=""
              value=""
              placeholder="Enter grace period (mis)"
              required
            />
            <Form.Control.Feedback type="invalid">
              Please enter valid grace period
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <Form.Group className="mt-3">
            <Form.Label>
              Fine Amount <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control name="" value="" placeholder="Enter fine amount" />
            <Form.Control.Feedback type="invalid">
              Please enter valid fine amount
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-5">
        <Col sm="6">
          <Form.Group className="mt-3">
            <Form.Label>
              Waive Off Days <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control name="" value="" placeholder="Enter waive off days" />
            <Form.Control.Feedback type="invalid">
              Please enter valid waive off days
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};

const LateComingPolicy = () => {
  return (
    <Form>
      <Form.Group>
        <div style={{ display: "flex", justifyContent: "start", gap: "20px" }}>
          <Form.Label>Fine Type</Form.Label>
          <Form.Check
            type="radio"
            name="fineType"
            value={"Daily"}
            label="Daily"
            required
          />
          <Form.Check
            type="radio"
            name="fineType"
            value={"Hourly"}
            label="Hourly"
            required
          />
        </div>
      </Form.Group>
      <Row>
        <Col sm="6">
          <Form.Group className="mt-3">
            <Form.Label>
              Grace Period (mis) <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              name=""
              value=""
              placeholder="Enter grace period (mis)"
              required
            />
            <Form.Control.Feedback type="invalid">
              Please enter valid grace period
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <Form.Group className="mt-3">
            <Form.Label>
              Fine Amount <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control name="" value="" placeholder="Enter fine amount" />
            <Form.Control.Feedback type="invalid">
              Please enter valid fine amount
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-5">
        <Col sm="6">
          <Form.Group className="mt-3">
            <Form.Label>
              Waive Off Days <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control name="" value="" placeholder="Enter waive off days" />
            <Form.Control.Feedback type="invalid">
              Please enter valid waive off days
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};

const OverTimePolicy = () => {
  return (
    <div>
      <div className="BasicDetails-form">
        <Form>
          <Row>
            <Col sm="6">
              <Form.Group>
                <Form.Label>
                  Grace Period (mis) <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  name=""
                  value=""
                  placeholder="Enter grace period (mis)"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please enter valid grace period
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm="6">
              <Form.Group className="mt-3">
                <Form.Label>
                  Extra Hours pay <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  name=""
                  value=""
                  placeholder="Enter extra hours pay"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter valid extra hours pay
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col sm="6">
              <Form.Group>
                <Form.Label>
                  Public Holiday Pay <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  name=""
                  value=""
                  placeholder="Enter public holiday pay"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter valid public holiday pay
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col sm="6">
              <Form.Group>
                <Form.Label>
                  Week Off Pay <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  name=""
                  value=""
                  placeholder="Enter waive off pay"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter valid week off pay
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default PenaltyOvertimeDetails;
